import React from 'react';
import { 
  Grid, 
  Typography, 
  Autocomplete, 
  TextField, 
  Button, 
  Stack, 
  Paper 
} from '@mui/material';
import { AiOutlineReload } from 'react-icons/ai';
import { FaPlus } from 'react-icons/fa';

const AddressStep = ({
  addressList,
  addressSelected,
  setAddressSelected,
  errors,
  control,
  Controller,
  addNewAddressOpen,
  getAddressClient,
  onNext
}) => {
  return (
    <div>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Endereço de Entrega
      </Typography>
      
      <Stack spacing={2} direction={{ xs: 'column', md: 'row' }} sx={{ mb: 3 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Button
            variant="contained"
            size="small"
            onClick={addNewAddressOpen}
            startIcon={<FaPlus />}
            style={{
              fontWeight: 'bold',
              textTransform: 'none',
              padding: '8px 16px',
              backgroundColor: 'black'
            }}
          >
            Novo Endereço
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={getAddressClient}
            style={{
              minWidth: '40px',
              height: '40px',
              padding: '8px',
              fontWeight: 'bold',
              textTransform: 'none',
              backgroundColor: 'black'
            }}
          >
            <AiOutlineReload />
          </Button>
        </div>
        
        <div style={{ flex: 1, maxWidth: '500px' }}>
          <Controller
            name="addressSelected"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={addressList}
                getOptionLabel={(option) => option.NM_ENDERECO || ""}
                value={addressList.find((address) => address.ID_DM002 === field.value) || null}
                onChange={(event, newValue) => {
                  setAddressSelected(newValue?.ID_DM002 || "");
                  field.onChange(newValue?.ID_DM002 || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecione o Endereço"
                    error={!!errors.addressSelected}
                    helperText={errors.addressSelected?.message}
                    fullWidth
                    size="small"
                  />
                )}
              />
            )}
          />
        </div>
      </Stack>

      {addressSelected && (
        <Paper elevation={3} style={{ padding: '16px', marginBottom: '24px' }}>
          <Typography variant="h6" gutterBottom>
            Endereço Selecionado
          </Typography>
          {addressList
            .filter((address) => address.ID_DM002 === addressSelected)
            .map((address) => (
              <div key={address.ID_DM002}>
                <Typography variant="body1">
                  <strong>Nome:</strong> {address.NM_ENDERECO}
                </Typography>
                <Typography variant="body1">
                  <strong>Rua:</strong> {address.DS_LOGRADOURO}, {address.NR_PREDIO} {address.DS_COMPLEMENTO ? `(${address.DS_COMPLEMENTO})` : ''} {address.DS_REFERENCIA ? `, (${address.DS_REFERENCIA})` : ''}
                </Typography>
                <Typography variant="body1">
                  <strong>Bairro:</strong> {address.NM_BAIRRO}
                </Typography>
                <Typography variant="body1">
                  <strong>Cidade:</strong> {address.NM_CIDADE} - {address.NM_UF}
                </Typography>
                <Typography variant="body1">
                  <strong>CEP:</strong> {address.NR_CEP}
                </Typography>
              </div>
            ))}
        </Paper>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
        <Button
          variant="contained"
          onClick={onNext}
          disabled={!addressSelected}
          size="large"
          sx={{ 
            px: 4,
            backgroundColor: 'black',
            '&:hover': {
              backgroundColor: '#333'
            }
          }}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default AddressStep;
